export function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}


// WEBPACK FOOTER //
// ./~/tiny-slider/src/helpers/isVisible.js